const L = {
  name: "Pencil",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4611)">
    <path d="M38.9202 8.63311L31.3719 1.08472C30.5962 0.308999 29.3332 0.308999 28.5575 1.08472L3.59558 26.0471C3.33701 26.3057 3.158 26.6239 3.06849 26.972L0.562357 37.0266C0.393292 37.7128 0.582247 38.4189 1.08944 38.9162C1.46735 39.2941 1.97454 39.5029 2.49168 39.5029C2.6508 39.5029 2.81987 39.483 2.97899 39.4433L13.0334 36.9271C13.3814 36.8376 13.6997 36.6586 13.9583 36.4L38.9202 11.4476C39.6959 10.6719 39.6959 9.40883 38.9202 8.63311ZM9.41339 35.7834L7.80231 36.1912L3.82431 32.2131L4.64975 28.8914L9.87086 34.1126C10.4178 34.6596 10.1593 35.5945 9.41339 35.7834ZM2.49168 37.5139L3.25745 34.4607L5.54479 36.7481L2.49168 37.5139ZM13.0632 34.4906L6.22105 27.6483C5.8332 27.2604 5.8332 26.6339 6.22105 26.246L24.9972 7.46952L31.8393 14.3118C32.2272 14.6997 32.2272 15.3262 31.8393 15.7141L13.0632 34.4906ZM33.9477 13.6057L27.1055 6.76342C26.7177 6.37556 26.7177 5.74901 27.1055 5.36115L29.9697 2.49694L36.8118 9.33922C37.1997 9.72708 37.1997 10.3536 36.8118 10.7415L33.9477 13.6057Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4611">
    <rect width="39" height="39" fill="currentColor" transform="translate(0.501945 0.50293)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  L as Pencil
};
